// extracted by mini-css-extract-plugin
module.exports = {"leftPanelContainer":"DetailLeftContainer_leftPanelContainer__2oToQ"};